// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module__wrapper___eW4F_","text":"styles-module__text___CaUE3","line":"styles-module__line___sr6uv"};